export const OutputFormatList = ['txt', 'doc', 'csv', 'parquet', 'delta', 'streaming', 'psv'];

export const PersistTypeList = [
  'DISK_ONLY',
  'DISK_ONLY_2',
  'MEMORY_ONLY',
  'MEMORY_ONLY_2',
  'MEMORY_AND_DISK',
  'MEMORY_AND_DISK_2',
];
